import React from "react";
import svglogo from "../../images/svglogo.png";

const Footer = () => {
  return (
    <div className="flex text-xs   text-gray-700 py-4 px-4 justify-center items-center emailSubscriptionBg flex-col">
      <div className="my-8">
        <img className="w-24" src={svglogo} alt={"logo"} />
      </div>
      <div>© 2026 Pittsburghprivateadvisors. All rights reserved </div>
    </div>
  );
};

export default Footer;
